import { Dispatch, MouseEvent, SetStateAction, useEffect, useRef, useState } from "react"
import classNames from "classnames"

import { SplitButtonProps } from "@/types/components/button"
import { colors } from "@/components/colors"
import { colorTokens } from "@/components/colorTokens"
import Icon from "@/components/icon/Icon"
import "./splitButton.scss"

export default function SplitButton({
  type,
  buttonText,
  list,
  onClickButton,
  onClickList,
  disabled,
  className,
  splitButtonClassName,
  ...props
}: SplitButtonProps) {
  const [open, setOpen] = useState(false)
  const handleOpen = () => setOpen(!open)
  const buttonRef = useRef<HTMLDivElement>(null)

  const mergedClassName = classNames("SplitButtonCont", [type, className], { disabled })

  useEffect(() => {
    const handleClickOutside: EventListener = (event) => {
      if (buttonRef.current && !buttonRef.current.contains(event.target as Node)) {
        setOpen(false)
      }
    }

    document.addEventListener("mousedown", handleClickOutside)

    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [])

  return (
    <div className={mergedClassName} ref={buttonRef} {...props}>
      <button className="left-btn" onClick={onClickButton}>
        <p>{buttonText}</p>
      </button>
      <div className="divider" />
      <button className={`right-btn ${open ? "active" : ""}`} onClick={handleOpen}>
        <Icon
          type="arrow-down"
          size={24}
          color={
            type === "default-outlined"
              ? open
                ? colorTokens.text["grey-primary"]
                : disabled
                  ? colorTokens.icon.disabled
                  : colorTokens.icon.primary
              : open
                ? colorTokens.interactive["btn-fill-text-enabled"]
                : disabled
                  ? colorTokens.interactive["btn-fill-text-disabled"]
                  : colorTokens.interactive["btn-fill-text-enabled"]
          }
        />
      </button>
      {open && (
        <SplitButtonList
          splitButtonClassName={splitButtonClassName}
          list={list}
          onClickList={onClickList}
          setOpen={setOpen}
        />
      )}
    </div>
  )
}

function SplitButtonList({
  list,
  onClickList,
  setOpen,
  splitButtonClassName,
}: { setOpen: Dispatch<SetStateAction<boolean>> } & Pick<
  SplitButtonProps,
  "list" | "onClickList" | "splitButtonClassName"
>) {
  // TODO event type
  const onClickItem = (e: MouseEvent, value: unknown) => {
    setOpen((prev) => !prev)
    onClickList(e, value)
  }

  return (
    <div className="SplitButton-list">
      {list.map((item) => (
        <button
          key={item.value}
          onClick={(e) => onClickItem(e, item.value)}
          value={item.value}
          disabled={item.disabled}
          className={splitButtonClassName}>
          <SplitButtonItem {...item} />
        </button>
      ))}
    </div>
  )
}

function SplitButtonItem({ label }: { label: string; value: string | number }) {
  return <p>{label}</p>
}
